// export const baseURL = 'http://172.16.1.177:3007'
// export const ImageUrl = 'http://172.16.1.177:3007/images/'
// export const ImageUrl2 = 'http://172.16.1.177:3007/'


const defaultUrl = (typeof window !== 'undefined' && (window.location.hostname === 'localhost' || window.location.hostname === '127.0.0.1'))
  ? 'http://localhost:3004'
  : 'https://api.bidbuyzoom.com';

const apiBase = (process.env.REACT_APP_BASE_URL || defaultUrl).replace(/\/$/, '');

export const baseURL = apiBase;
export const ImageUrl = `${apiBase}/images/`;
export const ImageUrl2 = apiBase;


// export const baseURL = 'http://localhost:3004'
// export const ImageUrl = 'http://localhost:3004/images/'
// export const ImageUrl2 = 'http://localhost:3004/'

export const google_api_key = 'AIzaSyBNPYbsmeUKRDH6WgLqnmyR2C60kgjkqoQ'